import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { EnvironmentConfig } from '../../../environments/environmentConfig'; import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'verify-identity',
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class verifyIdentityComponent implements OnInit {
  currentLang: string;
  identityObj: any = {};
  enumData: any;
  validDD: boolean[];
  currentRoutePath: string;
  applicantName: string;
  preQualObj: any;
  tooltipClicked: boolean = true;
  disableProceed: boolean;
  colorForTb: boolean = true;
  loader: boolean = false;
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  objQuestion: any;
  transactionKey: any;
  isIos: boolean;
  disableContinue: boolean = false;

  constructor(private _http: HttpClient, private changeDef: ChangeDetectorRef, private util: UtilService, private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService, private formUtiObj: FrameworkUtilityComponent, private router: Router) {
    this.isIos = !!navigator.platform && /iPad|iPhone|Mac|iPod/.test(navigator.platform);
    // 'slideTitles.startPage' is defined in en/fr.json
    this.util.sidebarTitle.next('slideTitles.identity');
    /**
     * Check if this screen is for primary or co-applicant and set the progress percentage
     */
    this.preQualObj = this.util.getSessionStorage();
    let progressPercent1 = sessionStorage.getItem("progressPercentage");

    if (Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONCENT_FIRST || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_CO_APPLICANT || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_PRIMARY || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONCENT_FIRST_APPLICANT || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_CO_APPLICANT) {
      let progressPrcnt = (this.preQualObj.is_coapplicant_applied == "Y") ? CONSTANTS.PROGRESS_PERCENTAGE.VERIFY_YOUR_1_IDENTITY_PRIMARY : CONSTANTS.PROGRESS_PERCENTAGE.VERIFY_YOUR_IDENTITY_PRIMARY;
      if (this.preQualObj.users.length == 2) {
        progressPrcnt = CONSTANTS.PROGRESS_PERCENTAGE.VERIFY_YOUR_IDENTITY_PRIMARY_2_CUSTOMER;
      }

      this.util.progressPercent.next(progressPrcnt);
      this.nextProgressPercent = progressPrcnt;
    } else {

    }

    this.util.isSidebarVisible.next(true);
    this.enumData = this.util.getEnumData();
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
  }
  ngOnInit(): void {
    this.colorForTb = true;
    this.preQualObj = this.util.getSessionStorage();
    this.currentLang = sessionStorage.getItem("currLang")
    this.formUtiObj.InitValues();
    this.validDD = [false];
    this.getquestionandAnsChoice();
    document.getElementById("sidebarTitle").focus();
  }

  //show hide tooltip

  funcTooltipClicked() {
    $(".tooltip-content").css("visibility", "visible");

    this.tooltipClicked = false;
  }

  fnFunctionChange(id) {
    if ($("#singleQues" + id).val()) {
      this.validDD[id] = false;
      $("#singleQues" + id).removeClass('invalidBorder');
      $("#singleQuesk" + id).addClass('displayNone');
    }
    else {
      this.validDD[id] = true;
      $("#singleQuesk" + id).removeClass('displayNone');
      $("#singleQues" + id).addClass('invalidBorder');
    }
  }

  fnFocusOut(evt, id) {


    if ($("#" + evt.target.id).val()) {
      this.validDD[id] = false;
      return;
    }
    if (!$("#" + evt.target.id).val()) {
      this.validDD[id] = true;
      $("#" + evt.target.id).addClass('invalidBorder');
      $("#singleQuesk" + id).removeClass('displayNone');
    }
    else {
      this.validDD[id] = false;
      $("#" + evt.target.id).removeClass('invalidBorder');
      $("#singleQuesk" + id).addClass('displayNone');
    }
  }

  /**
   * method to get question and answer
   */
  getquestionandAnsChoice() {
    let reqBody = {};
    this.loader = true;
    this.util.getquestionandAnsChoice(reqBody).subscribe((result: any) => {
      this.loader = false;
      this.objQuestion = false
      if (result) {
        this.loader = false
        this.objQuestion = true
        if (result.failure_code) {
          if (String(result.failure_code) == String("0003")) {
            this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
            return
          }
        }
        this.objQuestion = result.interactiveQuery;
        for (let i = 0; i < this.objQuestion.question.length; i++) {
          this.validDD.push(false);
        }
        this.transactionKey = result.transactionKey;
        this.applicantName = this.preQualObj.users[this.preQualObj.users.length - 1].firstname;

      }
    }, (error) => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    })
  }

  saveQuestion() {
    let reqObj = [];
    for (let k = 0; k < this.objQuestion.question.length; k++) {
      let objQuestion = { "question": this.objQuestion.question[k], "answerId": $("#" + this.objQuestion.question[k].question).val() }
      reqObj.push(objQuestion);
    }

  }


  //CloseTooltip
  closeTooltip() {
    setTimeout(() => {
      $(".tooltip-content").css("visibility", "hidden");

      this.tooltipClicked = true;
    }, 200);

  }

  checkDdlValues() {
    let indexchk = 0;
    for (let k = 0; k < this.objQuestion.question.length; k++) {
      if (!$("#singleQues" + this.objQuestion.question[k].questionId).val()) {
        if (k <= indexchk) {
          this.validDD[k + 1] = true;
          $("#singleQues" + this.objQuestion.question[k].questionId).addClass('invalidBorder');
          $("#singleQuesk" + this.objQuestion.question[k].questionId).removeClass('displayNone');
        }
        if (indexchk == 0) {
          $("#singleQuesk" + this.objQuestion.question[k].questionId).focus();
          indexchk = indexchk + 1;

        }
      }
      else {
        this.validDD[k + 1] = false;
        $("#singleQues" + this.objQuestion.question[k].questionId).removeClass('invalidBorder');
        $("#singleQuesk" + this.objQuestion.question[k].questionId).addClass('displayNone');

      }

    }
  }

  onContinue() {
    let tempFlag = false;
    this.disableContinue = true;
    let reqObj: any;
    reqObj = [];
    for (let k = 0; k < this.objQuestion.question.length; k++) {
      if (!$("#singleQues" + this.objQuestion.question[k].questionId).val()) {
        this.validDD[k + 1] = true;
        $("#singleQuesk" + this.objQuestion.question[k].questionId).show();
        $("#singleQuesk" + this.objQuestion.question[k].questionId).removeClass('displayNone');
        $("#singleQues" + this.objQuestion.question[k].questionId).addClass('invalidBorder');
        if (tempFlag == false) {
          $("#singleQues" + this.objQuestion.question[k].questionId).focus();
          tempFlag = true;
        }
        if (k == this.objQuestion.question.length - 1) {
          this.disableContinue = false;
          return;
        }
      }
      let objQuestion = { "questionId": this.objQuestion.question[k].questionId, "answerId": Number($("#singleQues" + this.objQuestion.question[k].questionId).val()) }
      reqObj.push(objQuestion);
      if (k == this.objQuestion.question.length - 1 && tempFlag) {
        this.disableContinue = false;
        return;
      }

    }
    let requestObject = {
      "transactionKey": this.transactionKey,
      "interactiveQueryId": this.objQuestion.interactiveQueryId,
      "answer": reqObj
    }

    this.disableContinue = true;
    this.util.assessmentScore(requestObject).subscribe((result: any) => {
      this.util.setSessionStorage(result);
      sessionStorage.setItem("progressPercentage", String(this.nextProgressPercent));
      if (result.failure_reason || result.failure_code || result.error == true) {
        this.disableContinue = false;
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      } else {
        let currpath = this.util.determineNextRoute("verify-identity");
        this.disableContinue = true;
        this.router.navigate([this.util.determineNextRoute("verify-identity")], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      // risk_strategy_decision
    }, (error) => {
      this.disableContinue = true;
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });

    })



  }

  // ngOnDestroy(){
  //   this.util.setCount(0)
  // }

}